import styled from "@emotion/styled";

const ColorCircle = styled.label`
  width: 20px;
  height: 20px;
  background-color: ${(props) => props.color};
  border-radius: 10px;
`;

export default ColorCircle;
